import { useTranslation } from "react-i18next"
import Swal from "sweetalert2"
import withReactContent from "sweetalert2-react-content"
import DOMPurify from "dompurify"

import {
  useGetPrivacyPolicyQuery,
} from "./privacyPolicyApiSlice"

export const PrivacyPolicy = () => {
  const { t } = useTranslation("gift_card")

  const {
    data: privacyPolicyData,
  } = useGetPrivacyPolicyQuery()

  return (
    <button className="underline"
      type="button"
      onClick={() => {
        withReactContent(Swal).fire({
          customClass: {
            container: "popup-container",
            popup: "popup w-[494px]! xl:w-[988px]!",
            closeButton: "popup-close",
            title: "popup-title text-lg! leading-8!",
            htmlContainer: "popup-text text-lg! leading-[1.4375rem]!",
          },
          heightAuto: false,
          showCloseButton: true,
          title: t("niki.gift_card.privacy_policy.title"),
          html: DOMPurify.sanitize(privacyPolicyData?.data?.body),
          showConfirmButton: false,
        })
      }}
    >
      {t("niki.gift_card.privacy_policy.title")}
    </button>
  )
}
